'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className"];
import PropTypes from 'prop-types';
import { Children } from 'react';
import { callIfPossible } from 'foundations-components/transitional/utils/functions';
import { DragHandle } from 'foundations-components/transitional/components/DragHandle';
import devLogger from 'react-utils/devLogger';
import { ConnectDragSourceContextConsumer } from '../context/ConnectDragSourceContext';
import { jsx as _jsx } from "react/jsx-runtime";
function wrapChildWithDragSource(child, connectDragSource) {
  const wrappedChild = /*#__PURE__*/_jsx("span", {
    children: /*#__PURE__*/_jsx(DragHandle, {
      children: child
    })
  });
  devLogger.warn({
    message: `You are using a stateless component as a child for DragListHandle.
      Because of this it had to be wrapped with a <span /> in order to work with drag and drop.
      To remove the span, please make the child component a react class.`
  });
  return callIfPossible(connectDragSource, wrappedChild);
}

/**
 * Draggable handle that is compatible with Foundations Components.
 * It uses DragHandle component from Foundations Components under the hood.
 * You should only use this component with functional components as children.
 * Do not pass class components as children.
 */
const DragListHandle = props => {
  const {
      children,
      className
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const child = Children.only(children);
  return /*#__PURE__*/_jsx(ConnectDragSourceContextConsumer, {
    children: connectDragSource => {
      if (children) {
        return /*#__PURE__*/_jsx(DragHandle, Object.assign({
          className: className
        }, rest, {
          _wrappedWithDnd: true,
          children: wrapChildWithDragSource(child, connectDragSource)
        }));
      }

      // Workaround to prevent error "Only native element nodes can now be passed to React DnD connectors"
      // when rendering a DragHandle with no children, specifically for UIExpandableSection #102
      const dragHandle = callIfPossible(connectDragSource, /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(DragHandle, Object.assign({
          className: className
        }, rest, {
          _wrappedWithDnd: true
        }))
      }));
      return dragHandle;
    }
  });
};
DragListHandle.displayName = DragHandle.displayName;
DragListHandle.propTypes = Object.assign({}, DragHandle.propTypes, {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object
});

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
DragListHandle.defaultProps = Object.assign({}, DragHandle.defaultProps);
export default DragListHandle;